module.exports = __webpack_public_path__ + "img/about.e2f90380.svg";